
import VueSlickCarousel from 'vue-slick-carousel';
import IconArrowRightSmall from '~/components/icons/IconArrowRightSmall.vue';

export default {
  components: { VueSlickCarousel, IconArrowRightSmall },
  data () {
    return {
      currentIndex: 0
    };
  },
  methods: {
    updateSlide (_o, n) {
      this.currentIndex = n;
    },
    nextSlide () {
      if (this.$refs.slider) { this.$refs.slider.next(); }
    },
    prevSlide () {
      if (this.$refs.slider) { this.$refs.slider.prev(); }
    }
  }
};
